export const SESSION_STORAGE_PSA = 'PSA';
export const SESSION_STORAGE_PSA_ID = 'PSA_ID';
export const SESSION_STORAGE_TICKET_ID = 'TICKET_ID';
export const SESSION_STORAGE_SCREEN = 'SCREEN';
export const SESSION_STORAGE_URL = 'url';
// Set by SecureAttachmentAuthStart before redirecting, read by SecureAttachmentAuthEnd on return —
// the two pages are separate page loads, so this is the only way to pass which provider was used.
export const SESSION_STORAGE_TEAMS_AUTH_PROVIDER = 'teamsAuthProvider';
